// extracted by mini-css-extract-plugin
export var avatarContainer = "_a0-0";
export var avatarTypingWave = "_a0-i";
export var gray = "_a0-f";
export var green = "_a0-c";
export var icon = "_a0-9";
export var image = "_a0-1";
export var lg = "_a0-6";
export var md = "_a0-5";
export var presenceDot = "_a0-b";
export var red = "_a0-d";
export var sm = "_a0-4";
export var status = "_a0-a";
export var typingDot = "_a0-h";
export var typingPill = "_a0-g";
export var xl = "_a0-7";
export var xs = "_a0-3";
export var xxl = "_a0-8";
export var xxs = "_a0-2";
export var yellow = "_a0-e";